import { useContext, createContext } from 'react';
import { OrderPathParams, EditOrderPathParams } from '@app/react/const/type';

export const OrderPathParamsContext = createContext();

type RT = OrderPathParams | EditOrderPathParams;
export const useOrderPathParams = (): RT => useContext(OrderPathParamsContext);
